import produce from "immer";
import IMyDeliveriesReducer from "models/IMyDeliveriesReducer";
import { actionTypes } from "./actions";
import { myDeliveriesSorting as defaultSorting } from "constants/sorting";

const initialState: IMyDeliveriesReducer = {
  isLoading: false,
  isLoaded: false,
  items: [],
  selectedDeliveries: null,
  meta: {
    defaultSorting
  },
  currentItem: null,
  error: null
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_MY_DELIVERIES_SUCCESS:
        draftState.items = action.payload;
        draftState.meta = action.meta;
        break;
      case actionTypes.FORM_INIT:
        draftState.selectedDeliveries = action.payload;
        break;
      case actionTypes.MY_DELIVERIES_FAILURE:
        draftState.error = action.error;
        break;
    }
  });
